import useTranslator from "../../hooks/useTranslator";

export type ApplicationFeedbackData = {
  documents?: string[];
  message?: string;
  status?: string;
  resolved_at?: string | null;
  updated_at?: string;
};

export type ApplicationData = {
  _id?: string;
  title?: string;
  feedback?: ApplicationFeedbackData | null;
};

const ApplicationFeedback = ({
  application,
}: {
  application?: ApplicationData | null;
}) => {
  const { _t } = useTranslator();
  const feedback = application?.feedback;
  if (!feedback) return null;
  // Feedback saved before statuses were introduced is treated as OPEN.
  const status = feedback.status || "OPEN";
  if (status !== "OPEN") return null;
  const message = (feedback.message || "").trim();
  const documents = Array.isArray(feedback.documents)
    ? feedback.documents.filter(Boolean)
    : [];
  if (!message && documents.length === 0) return null;

  return (
    <section
      className="application-feedback"
      aria-label={_t("applicationFeedback", "Application feedback")}
    >
      <strong className="application-feedback-title">
        {_t("applicationFeedbackTitle", "Changes requested on your application")}
      </strong>
      <div className="application-feedback-body">
        {message && (
          <div className="application-feedback-block">
            <span className="application-feedback-label">
              {_t("applicationFeedbackMessageLabel", "Message")}
            </span>
            <p className="application-feedback-message">{message}</p>
          </div>
        )}
        {documents.length > 0 && (
          <div className="application-feedback-block">
            <span className="application-feedback-label">
              {_t("applicationFeedbackDocumentsLabel", "Documents")}
            </span>
            <p className="application-feedback-documents">
              {documents.join(", ")}
            </p>
          </div>
        )}
      </div>
    </section>
  );
};

export default ApplicationFeedback;
